//* Libraries imports
import z from "zod";

//* Schemas imports
export const questionSummary = z.object({
  id: z.number(),
  name: z.string(),
  numero: z.number(),
  typeQuestao: z.string(),
});
export type QuestionSummary = z.infer<typeof questionSummary>;

export const categoryWithQuestions = z.object({
  id: z.number(),
  name: z.string(),
  order: z.number(),
  questoesCount: z.number(),
  questoes: z.array(questionSummary),
});
export type CategoryWithQuestions = z.infer<typeof categoryWithQuestions>;

export const examWithFilters = z.object({
  id: z.number(),
  name: z.string(),
  type: z.string(),
  totalQuestoes: z.number(),
  categorias: z.array(categoryWithQuestions),
});
export type ExamWithFilters = z.infer<typeof examWithFilters>;

export const processExamFiltersResponse = z.object({
  result: z.boolean(),
  data: z.object({
    processoId: z.number(),
    processoName: z.string(),
    provas: z.array(examWithFilters),
    totalProvas: z.number(),
  }),
});
export type ProcessExamFiltersResponse = z.infer<typeof processExamFiltersResponse>;

export const processExamFiltersParams = z.object({
  search: z.string().optional(),
  categoria_id: z.number().optional(),
});
export type ProcessExamFiltersParams = z.infer<typeof processExamFiltersParams>;
